import _parseInt from 'lodash/parseInt';
import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_ROLLOUTS_LIST,
  GET_ROLLOUTS_LIST_SUCCESS,
  GET_ROLLOUTS_LIST_ERROR,
  GET_ROLLOUT,
  GET_ROLLOUT_SUCCESS,
  GET_ROLLOUT_ERROR,
  ADD_ROLLOUT,
  ADD_ROLLOUT_SUCCESS,
  ADD_ROLLOUT_ERROR,
  DELETE_ROLLOUT,
  DELETE_ROLLOUT_SUCCESS,
  DELETE_ROLLOUT_ERROR,
  GET_ROLLOUT_DEVICES_LIST,
  GET_ROLLOUT_DEVICES_LIST_SUCCESS,
  GET_ROLLOUT_DEVICES_LIST_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize, deserializeDevice } from '../../models/rollout';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.rollout;
const rollout = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullRollout') {
        return {
          ...state,
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'currentRollout':
          key = 'current';
          break;
        case 'addRollout':
          key = 'add';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case GET_ROLLOUTS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_ROLLOUTS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_ROLLOUTS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // GET
    case GET_ROLLOUT:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_ROLLOUT_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_ROLLOUT_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // ADD
    case ADD_ROLLOUT:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
        },
      };
    case ADD_ROLLOUT_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: action.error,
        },
      };
    case ADD_ROLLOUT_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // DELETE
    case DELETE_ROLLOUT:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_ROLLOUT_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_ROLLOUT_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // DEVICES LIST
    case GET_ROLLOUT_DEVICES_LIST:
      return {
        ...state,
        devicesList: {
          ...state.devicesList,
          loading: true,
          error: null,
          elements: {
            ...state.devicesList.elements,
            data: null,
          },
        },
      };
    case GET_ROLLOUT_DEVICES_LIST_ERROR:
      return {
        ...state,
        devicesList: {
          ...state.devicesList,
          loading: false,
          error: action.error,
        },
      };
    case GET_ROLLOUT_DEVICES_LIST_SUCCESS:
      return {
        ...state,
        devicesList: {
          ...state.devicesList,
          loading: false,
          elements: {
            ...state.devicesList.elements,
            data: _map(action.data.data, (rolloutDevice) => (
              deserializeDevice({
                id: rolloutDevice.device.id,
                ...rolloutDevice,
              })
            )),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    default:
      return state;
  }
};

export default rollout;



// WEBPACK FOOTER //
// ./reducers/updates/rollout.js